<template>
   <dashboard-layout>
      <v-container fluid class="down-top-padding py-0">
         <BaseBreadcrumb
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="breadcrumbs"
         ></BaseBreadcrumb>
         <v-row>
            <v-col cols="12">
               <table-annual-reports></table-annual-reports>
            </v-col>
         </v-row>
      </v-container>
   </dashboard-layout>
</template>

<script>
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import TableAnnualReports from './Tables/TableAnnualReports.vue';

export default {
   name: "MOAAnnualReports",

   props: ['user'],

   data() {
      return {
         page: {
         title: "Manage Annual Reports",
         },
         breadcrumbs: [
            {
               text: "Dashboard",
               disabled: false,
               to: "/dashboard",
            },
            {
               text: "Annual Reports",
               disabled: true,
            },
         ],
      }
   },

   components: {
      DashboardLayout,
      BaseBreadcrumb,
      TableAnnualReports,
      // TheSalesCards: () => import("@/components/dashboards/dashboardComponents/sales-cards/SalesCards"),
      // TheSalesOverview: () => import("@/components/dashboards/dashboardComponents/sales-overview/TheSalesOverview"),
      // TheVisitSeparation: () => import("@/components/dashboards/dashboardComponents/visit-separation/TheVisitSeparation"),
   },

   methods: {
      dashtype: function() {
         return (this.user.membertype === 'members' ? 'Members Dashboard' : 'Admin Dashboard')
      }
   },

   computed: {

   }


};
</script>

<style>
</style>
